import Base64 from "@repo/utils/Base64";
import Organization from "./Organization.js";

type Product = {
  id: Product.Id;
  organizationId: Organization.Id;

  name: string;
  description?: string;
  imgUrl: string;
  priceCents: number;
  stock?: number;
  sku?: string;
};

namespace Product {
  export type Id = `rp_${string}`;

  export namespace Id {
    export const is = (id: string | undefined | null): id is Id =>
      !!id?.startsWith("rp_");
  }

  export type Params = Pick<
    Product,
    "name" | "description" | "priceCents" | "stock" | "sku"
  > & {
    imgBase64: Base64;
  };
  export namespace Params {
    export type Update = Partial<
      Omit<Product.Params, "stock"> & {
        stockOperation: {
          type: "add" | "reduce" | "set";
          amount: number;
        };
      }
    >;
  }
}

export default Product;
